import React, { useState, useEffect } from 'react';

interface WelcomeSectionProps {
  currentUser: any;
  clinicSettings: any;
}

export const WelcomeSection: React.FC<WelcomeSectionProps> = ({ currentUser, clinicSettings }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return 'Selamat Pagi';
    if (hour < 17) return 'Selamat Siang';
    if (hour < 19) return 'Selamat Sore';
    return 'Selamat Malam';
  };

  return (
    <div className="mb-8 p-6 bg-gradient-to-r from-cyan-600 to-cyan-800 rounded-xl shadow-lg text-white">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {getGreeting()}, {currentUser?.name}!
          </h1>
          <p className="mt-2 text-cyan-100 opacity-90">
            Selamat datang di Sistem Manajemen {clinicSettings?.clinic_name || 'Klinik'}. Berikut adalah ringkasan hari ini.
          </p>
        </div>
        
        {/* Widget Jam & Tanggal */}
        <div className="mt-4 md:mt-0 bg-white/10 backdrop-blur-md px-5 py-3 rounded-xl border border-white/20 shadow-sm flex flex-col md:items-end">
          <div className="text-2xl md:text-3xl font-bold tabular-nums tracking-wide">
            {currentTime.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
          </div>
          <div className="text-cyan-100 text-sm md:text-base mt-1 font-medium">
            {currentTime.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>

      {clinicSettings?.clinic_name && (
        <div className="mt-6 p-4 bg-white/10 backdrop-blur-md rounded-lg border border-white/20">
          <h2 className="text-xl font-semibold mb-2">{clinicSettings.clinic_name}</h2>
          <div className="flex flex-col md:flex-row md:space-x-6 text-sm text-cyan-50">
            {clinicSettings.clinic_address && (
              <span className="flex items-center mb-1 md:mb-0">
                <span className="mr-2">📍</span> {clinicSettings.clinic_address}
              </span>
            )}
            {clinicSettings.clinic_phone && (
              <span className="flex items-center mb-1 md:mb-0">
                <span className="mr-2">📞</span> {clinicSettings.clinic_phone}
              </span>
            )}
            {clinicSettings.clinic_email && (
              <span className="flex items-center">
                <span className="mr-2">📧</span> {clinicSettings.clinic_email}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
